import React from 'react';

const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));

const from24Hour = (value) => {
  if (!value) return { hour: 12, minute: '00', period: 'AM' };
  const [hh, mm] = value.split(':');
  let hour = parseInt(hh, 10);
  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return { hour, minute: mm, period };
};

const to24Hour = (hour, minute, period) => {
  let h = Number(hour) % 12;
  if (period === 'PM') h += 12;
  return `${String(h).padStart(2, '0')}:${minute}`;
};

// A 12-hour time picker. Native <input type="time"> silently renders in
// 24-hour format on Safari/macOS when the OS is set to 24-hour time,
// regardless of the page's locale — this always shows AM/PM.
const TimeInput = ({ value, onChange }) => {
  const { hour, minute, period } = from24Hour(value);

  const update = (next) => onChange(to24Hour(next.hour ?? hour, next.minute ?? minute, next.period ?? period));

  return (
    <div className="time-input">
      <select value={hour} onChange={(e) => update({ hour: e.target.value })}>
        {HOURS.map((h) => (
          <option key={h} value={h}>{h}</option>
        ))}
      </select>
      <select value={minute} onChange={(e) => update({ minute: e.target.value })}>
        {MINUTES.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      <select value={period} onChange={(e) => update({ period: e.target.value })}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
};

export default TimeInput;
